export function shanghaiDate(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date)
  const value = (type) => parts.find((part) => part.type === type)?.value
  return `${value('year')}-${value('month')}-${value('day')}`
}

export function dailyRankingNotice(data) {
  if (!data?.isFallback) return data?.message || ''
  if (data.requestedDate === shanghaiDate()) {
    return '今日榜单尚未发布，当前显示最近一期'
  }
  return data.message || '所选日期暂无已发布榜单，当前显示最近一期'
}

export function repoSummaryText(repo) {
  if (repo?.summary) return repo.summary
  if (repo?.description) return repo.description
  if (repo?.isAiFallback || repo?.aiStatus === 'fallback') {
    return '该项目暂无历史 AI 解读，可先查看 GitHub 项目页与详情。'
  }
  return '该项目暂未提供 AI 解读。'
}

export function repoReasonText(repo) {
  if (repo?.reason) return repo.reason
  if (repo?.isAiFallback || repo?.aiStatus === 'fallback') {
    return '该项目按 GitHub Star 总数进入总榜'
  }
  return '该项目进入当前榜单，建议查看项目详情。'
}
